import request from '@/utils/request'

// 查询商品分组列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/layout/page',
        method: 'get',
        params: query,
    })
}
//  新增商品分组
export function addObj(data) {
    return request({
        url: '/upkeep/layout/add',
        method: 'post',
        data: data,
    })
}
// 更改状态
export function statusObj(data) {
    return request({
        url: '/upkeep/layout/status',
        method: 'post',
        data: data,
    })
}
// 修改商品分组
export function putObj(data) {
    return request({
        url: '/upkeep/layout/edit',
        method: 'post',
        data: data,
    })
}
// 删除商品分组
export function delObj(data) {
    return request({
        url: '/upkeep/layout/delete',
        method: 'post',
        data: data,
    })
}
// 查询商品分组详细
export function getObj(id) {
    return request({
        url: '/upkeep/layout/detail?id=' + id,
        method: 'get',
    })
}